import { produce } from "immer";
import ACTIONS from "../actions/types.actions";

const helperText = produce((draft, action) => {
  switch (action.type) {
    case ACTIONS.HELPER_TEXT_REQUEST:
      draft[action.key] = true;
      return draft;
    case ACTIONS.HELPER_TEXT_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.value = action.response;
      return draft;
    case ACTIONS.HELPER_TEXT_LIST_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.list = action.response.list;
      draft.lookupList = action.response.lookupList;
      return draft;
    case ACTIONS.HELPER_TEXT_ERROR:
      draft.loading = false;
      draft.error = action.error;
      return draft;
    default:
      return draft;
  }
});

export default helperText;
